import { createFileRoute, Navigate, Outlet } from "@tanstack/react-router";
import { useConvexAuth } from "convex/react";
import { Rail } from "@/app/rail";
import { UiProvider } from "@/app/ui-state";
import { DesktopOrg } from "@/features/desktop/chrome";
import { OrgProvider } from "@/lib/org";

// Everything behind sign-in. The frame is the Revision Labs layout from Paper: an 8px
// ground, the rail, then floating cards that each route fills.
export const Route = createFileRoute("/_app")({ component: AppFrame });

const Ground = () => <div className="h-full bg-app" />;

function AppFrame() {
  const { isLoading, isAuthenticated } = useConvexAuth();
  if (isLoading) return <Ground />;
  if (!isAuthenticated) return <Navigate to="/sign-in" />;
  return (
    <OrgProvider fallback={<Ground />}>
      <UiProvider>
        <DesktopOrg />
        <div className="flex h-full min-h-0 gap-2 bg-app p-2">
          <Rail />
          <Outlet />
        </div>
      </UiProvider>
    </OrgProvider>
  );
}
